import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'antd';

import HowItWorks from 'components/Tour/HowItWorks/HowItWorks';

import { setSidebarContent } from 'features/sidebar/sidebarSlice';

import { useAppDispatch } from 'hooks/useTypedRedux';

import { SidebarContentTypes } from 'constants/enums';

import { ReactComponent as EnvelopeIcon } from 'assets/icons/sms.svg';

import styles from './FeedbackSection.module.scss';

const FeedbackSection: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const handleFeedbackButtonClick = () => {
    dispatch(
      setSidebarContent({ contentId: SidebarContentTypes.FeedbackView })
    );
  };

  return (
    <section className={styles.sectionWrapper}>
      <div className={styles.wrap}>
        <div className={styles.text}>{t('footer.feedback.text')}</div>

        <div className={styles.button}>
          <Button
            type="primary"
            className={styles.button}
            onClick={handleFeedbackButtonClick}
          >
            <EnvelopeIcon className={styles.icon} />
            {t('footer.feedback.title')}
          </Button>
        </div>
      </div>
      <HowItWorks />
    </section>
  );
};

export default FeedbackSection;
